import { StyleSheet } from 'aphrodite'
import { Common } from 'styles'

const styles = StyleSheet.create({
  motionContainer: {
    overflow: 'hidden',
    position: 'relative'
  },
  container: {
    order: 0,
    width: Common.nodeMenuWidth - 1,
    minWidth: Common.nodeMenuWidth - 1,
    borderRight: '1px solid #efefef',
    fontSize: 11,
    height: '100%'
  },
  nodeIconContainer: {
    padding: 10,
    height: 18,
    width: '100%',
    display: 'flex',
    borderBottom: '1px solid #efefef'
  },
  innerContainer: {
    padding: 10
  },
  input: {
    border: '1px solid rgb(204, 204, 204)',
    width: 'calc(100% - 8px)',
    borderRadius: 2,
    outline: 'none',
    padding: 3
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/Node/styles.js